import { fn, hash } from '@ember/helper';

import { not } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import DirectorySelect from 'umg-ember-backend/components/ui/directory-select';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsSftpUserComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='username' />
            <fieldset.field
              @property='user'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />

            <DirectorySelect
              @onSelect={{fn (mut @model.homedir)}}
              @root='/'
              @selected={{@model.homedir}}
              @server='sftp.universal-music-services.de:4444'
            >
              <fieldset.field @property='homedir' />
            </DirectorySelect>

            <fieldset.field @property='purpose' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='validity' as |fieldset|>
            <fieldset.field @property='livedate' @type='date' />
            <fieldset.field @property='killdate' @type='date' />
            <fieldset.field
              @property='passwordCreated'
              @type='date'
              @disabled={{true}}
            />
            <fieldset.field @property='passwordValid' />
          </form.fieldset>

          <form.fieldset @titleKey='ip' as |fieldset|>
            <fieldset.field
              @property='ip'
              @disabled={{not form.model.manualIp}}
            />
            <fieldset.field @property='manualIp' @type='checkbox' />
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
